/** M7 financial statements (per CLIENT). */

export type StatementType = "PROFIT_LOSS" | "BALANCE_SHEET" | "CASH_FLOW";

export interface FinancialStatement {
  id: string;
  periodLabel: string;
  statementType: StatementType;
  summary: string;
  preparedBy: string;
  createdAt: string;
}

export interface CreateStatementPayload {
  period_label: string;
  statement_type: StatementType;
  summary?: string;
}

export const STATEMENT_TYPE_OPTIONS: { value: StatementType; label: string }[] = [
  { value: "PROFIT_LOSS", label: "Profit & Loss" },
  { value: "BALANCE_SHEET", label: "Balance Sheet" },
  { value: "CASH_FLOW", label: "Cash Flow" },
];

export const STATEMENT_TYPE_LABEL: Record<StatementType, string> = {
  PROFIT_LOSS: "Profit & Loss",
  BALANCE_SHEET: "Balance Sheet",
  CASH_FLOW: "Cash Flow",
};
